import React from 'react';
import { useLocalization, useTranslate } from '@im/react-localization';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { styled } from '@mui/material/styles';

export const ErrorContentLocalizedX4C = () => {
  const { translate } = useLocalization();
  const translateStr = useTranslate();

  return (
    <Root id="error-boundary-lo-x4c">
      <img
        alt={translateStr('Common.Somethingwentwrong')}
        src="/xshared/assets/img/errorBoundary.svg"
        style={{ marginBottom: '50px' }}
      />
      <Typography sx={{ fontSize: '14px', lineHeight: '22px' }}>
        {translate('ErrorBoundary.ErrorText', undefined, true)}
      </Typography>

      <Typography
        sx={{ fontSize: '20px', lineHeight: '28px', margin: '32px 0px' }}
        variant="h2"
      >
        {translate('Common.PageErrorMainText')}
      </Typography>
      <Button
        href="/cep/app/home"
        startIcon={<ArrowBackIcon />}
        sx={{ fontSize: '14px', lineHeight: '22px', textTransform: 'none' }}
        variant="contained"
      >
        {translate('Common.BackToHome')}
      </Button>
    </Root>
  );
};
const Root = styled('div')(() => ({
  margin: '50px auto 0px',
  maxWidth: '1500px',
  textAlign: 'center',
}));
